<template>
  <textarea
    v-bind="proxyAttrs"
    v-model="proxyValue"
    v-fusioninputcheck="checkerObject"
    v-on="$listeners"
  />
</template>

<script>
import { getCurrentInstance, computed } from 'vue-demi'
import i18n from '@/utils/i18n'
import { validateEmails } from './HKLInputEmails.service'

export const SOURCE = 'value'
export const EVENT = 'onChange'

export default {
  name: 'HKLInputEmails',
  components: {
  },
  model: {
    prop: SOURCE,
    event: EVENT,
  },
  props: {
    [SOURCE]: {
      type: String,
      default: () => '',
      required: true,
    },
    checkerOptions: {
      type: Object,
      default: () => ({}),
    },
    separator: {
      type: String,
      default: () => ';',
      validator: (val) => val.length,
    },
  },
  setup (props, { emit }) {
    const { proxy } = getCurrentInstance()
    const checkerObject = computed(() => {
      return Object.assign({
        type: 'string',
        tip: i18n.t('hint.inputTip.email'),
        pattern: validateEmails(props.separator),
        classes: 'tooltip-class',
        required: props[SOURCE].trim(),
      }, typeof props.checkerOptions === 'object' && props.checkerOptions)
    })
    const proxyAttrs = computed(() => {
      return Object.assign({ }, proxy.$attrs)
    })
    const proxyValue = computed({
      get () { return props[SOURCE] },
      set (newValue) {
        emit(EVENT, newValue)
      },
    })

    return {
      proxyAttrs,
      proxyValue,
      checkerObject,
    }
  },
}
</script>
